<template>
  <ib-dialog
    :visible="dialogUpgradeVisible"
    width="400px"
    :closable="false"
    :append-to-body="true"
    empty-header
    @close="closeDialog"
  >
    <!--    <div class="text-center">-->
    <!--      <div class="illustration-wrapper">-->
    <!--        <img src="@/assets/img/illustrations/dialogs/upgrade-rocket.svg" alt="">-->
    <!--      </div>-->
    <!--      <h1>{{ $t('dialogs.upgrade.title') }}</h1>-->
    <!--      <p class="text-lead">-->
    <!--        {{ $t('dialogs.upgrade.description') }}-->
    <!--      </p>-->
    <!--    </div>-->

    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/dialogs/upgrade-rocket.svg')"
      :title="$t('dialogs.upgrade.title')"
      :subtitle="$t('dialogs.upgrade.description')"
    />
    <!-- /Dialog Content -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :cancel-btn-text="$t('cancel')"
        :submit-btn-text="$t('upgradeNow')"
        @submit="onSubmit"
        @cancel="closeDialog"
      />
    </template>
  </ib-dialog>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'DialogUpgrade',

  props: {
    dialogUpgradeVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    ...mapMutations('app', ['setRedirectRouteAfterPayment']),

    onSubmit () {
      this.setRedirectRouteAfterPayment(this.$route.name)
      this.$router.push({ name: 'payment' })
      this.closeDialog()
    },

    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.text-lead {
  font-size: 1.5rem;
  opacity: 0.5;
}
</style>
